import React, {Fragment, useEffect, useState} from "react";
import {IRound} from "../_interfaces/IRound";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import TextField from "@mui/material/TextField";
import {v4} from "uuid";
import {CircularProgress, List, ListItem, Typography} from "@mui/material";
import {logout} from "../_helper/logout";
import StartIcon from '@mui/icons-material/Start';
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";

type Props = {
    startRound: (rid: string) => void
}
export default function GM({startRound}: Props) {

    const [loading, setloading] = useState(false)
    const [rounds, setRounds] = useState<IRound[]>([])
    const [addRound, setAddRound] = useState(false)
    const [addname, setaddname] = useState('')
    const [adddescription, setadddescription] = useState('')
    const [addroundresult, setaddroundresult] = useState('')

    useEffect(() => {
        fetchRounds()
    }, []);

    const activateRound = (id: string) => {
        fetch(apiAddress + "/rounds/activate/" + id, createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('active')) {
                fetchRounds()
            }
        })
        localStorage.setItem('round', id);
    }

    const start = (id: string) => {
        startRound(id);
    }

    const fetchRounds = () => {
        fetch(apiAddress + "/rounds/gm", createOptions('GET'))
            .then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('rounds')) {
                console.log('fetchRounds', data.rounds)
                setRounds(data.rounds)
            }
            if (data.hasOwnProperty('err')) {
                console.log('err', data.err)
                if (data.err.name === "TokenExpiredError") {
                    window.alert('Sitzung abgelaufen, neu anmelden');
                    logout()
                }
            }
        }).catch((err) => {
            console.log('fetchRounds catch', err)
        })
    }


    const add = () => {
        setloading(true);
        setaddroundresult('');
        fetch(apiAddress + "/rounds/create", createOptions('POST', {
                id: v4(),
                name: addname,
                description: adddescription
            })
        ).then((res) => res.json()).then((data) => {
            if (data.hasOwnProperty('result')) {
                fetchRounds();
                setaddname('');
                setadddescription('');
            }
            if (data.hasOwnProperty('msg')) {
                setaddroundresult(data.msg);
            }
            setloading(false);
        });
    }

    const roundRow = (r: IRound) => {
        return <ListItem key={r.id}>
            <Grid container spacing={1}>
                <Grid item xs={5}>{r.name}</Grid>
                <Grid item xs={2}>{r.active === 1 ? 'aktiv' : '-'}</Grid>
                <Grid item xs={2}>{r.chars === 0 ? 'keine' : r.chars}</Grid>
                <Grid item xs={3}>
                    <FormControl variant="standard" style={{width: '100%', alignItems: 'center'}}>
                        {r.active === 1 ?
                            <Button onClick={() => start(r.id)}>beitreten</Button>
                            :
                            <Button onClick={() => activateRound(r.id)}>aktiv schalten</Button>
                        }
                    </FormControl>
                </Grid>
                {r.description ?
                    <Grid item xs={12} style={{marginLeft: 12, fontStyle: 'italic'}}>{r.description}</Grid> : null}
            </Grid>
        </ListItem>
    }

    const addRoundForm = () => {
        return <Paper key={'addRoundForm'}>
            <Typography variant="h6" gutterBottom>Runde erstellen</Typography>
            <Grid container spacing={1}>
                <Grid item xs={4}>
                    <TextField onChange={e => setaddname(e.target.value)}
                               value={addname}
                               variant="standard"
                               label="Name:"/>
                </Grid>
                <Grid item xs={4}>
                    <TextField onChange={e => setadddescription(e.target.value)}
                               value={adddescription}
                               variant="standard"
                               label="Description:"/>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}>
                    <Button onClick={add}>erstellen</Button>
                </Grid>
            </Grid>
        </Paper>
    }

    return <Fragment>
        {loading ? <CircularProgress></CircularProgress> : null}
        <Paper>
            <Typography variant="h4" style={{padding: '16px 16px 0 16px'}}>Runden</Typography>
            <List>
                <ListItem key={v4()} style={{backgroundColor: '#efefef'}}>
                    <Grid container spacing={1}>
                        <Grid item xs={5}>Name</Grid>
                        <Grid item xs={2}>Aktiv?</Grid>
                        <Grid item xs={2}>Charaktere</Grid>
                        <Grid item xs={3}></Grid>
                    </Grid>
                </ListItem>
                {rounds.map(r => roundRow(r))}
            </List>
        </Paper>
        <Paper style={{marginTop: 4}}>
            <Button onClick={() => setAddRound(true)}>Neue Runde erstellen</Button>
        </Paper>
        {addRound ? addRoundForm() : null}
        {addroundresult ? <Grid item xs={12}>
            {addroundresult}
        </Grid> : null}
    </Fragment>
}